import { useTypedTranslate } from 'providers/i18n/hooks/useTypedTranslate';
import * as yup from 'yup';

export const useYupSchema = () => {
  const translate = useTypedTranslate();

  const paymentMaxField = yup
    .number()
    .typeError(translate('app.validation.enterNumber'))
    .nullable();
  const paymentMinField = yup
    .number()
    .typeError(translate('app.validation.enterNumber'))
    .when('paymentMax', {
      is: (value: number) => !!value,
      then: (schema) =>
        schema.lessThan(
          yup.ref<number>('paymentMax'),
          translate('app.validation.minGreaterThanMax'),
        ),
    })
    .nullable();

  const payoutMaxField = yup.number().typeError(translate('app.validation.enterNumber')).nullable();
  const payoutMinField = yup
    .number()
    .typeError(translate('app.validation.enterNumber'))
    .when('payoutMax', {
      is: (value: number) => !!value,
      then: (schema) =>
        schema.lessThan(
          yup.ref<number>('payoutMax'),
          translate('app.validation.minGreaterThanMax'),
        ),
    })
    .nullable();

  return yup.object().shape({
    currency: yup.string().required(translate('app.validation.required')),
    gateway: yup.string().required(translate('app.validation.required')),
    paymentMax: paymentMaxField,
    paymentMin: paymentMinField,
    payoutMax: payoutMaxField,
    payoutMin: payoutMinField,
  });
};
